export const SNHU_EXTRA_ENTRIES = window.FKL.snhuExtraEntries || 25;
